import Title from "antd/es/typography/Title";
import React from "react";
import { UserOutlined, LockOutlined, EyeOutlined } from "@ant-design/icons";
import "./index.scss";
import FeatureCard from "./Components/IconText";
import StealthPreview, { Hidden } from "../../../../Components/StealthPreview";
import { builtForLeadersCards } from "../../../../Utils/staticData";

// A profile as companies see it with Stealth Mode on and off, like the
// candidate app's stealth mode preview: name and company blurred when on.
// Same candidate as the live demo. Off, the profile goes only to companies
// whose roles the candidate indicated interest in, never to everyone.
const profilePreview = {
  stealth: {
    avatar: <UserOutlined />,
    title: <Hidden label="Name hidden">Candidate Name</Hidden>,
    subtitle: (
      <>
        VP of Sales, <Hidden label="current company hidden">Confidential</Hidden>
      </>
    ),
    location: "New York, NY",
    noteIcon: <LockOutlined />,
    note: "Name, company and photo hidden until a match",
  },
  visible: {
    avatar: "JM",
    title: "Jordan M.",
    subtitle: "VP of Sales, Meridian SaaS",
    location: "New York, NY",
    noteIcon: <EyeOutlined />,
    note: "Shared with companies whose roles you're interested in",
  },
};

const Maintain = () => {
  return (
    <div className="built-for-leaders-container" id="built-for-talent">
      <div className="section-header">
        <Title level={2} className="section-heading">
          Built for Talent
        </Title>
      </div>

      {/* Mirrors the job-posting switch in "Built for Hiring Teams". */}
      <div className="talent-stealth-card">
        <StealthPreview
          heading="Company view"
          className="talent-stealth-preview"
          {...profilePreview}
        />
        <h3 className="talent-stealth-title">Choose what companies see</h3>
        <p className="talent-stealth-description">
          Flip Stealth Mode to preview your profile. On, your name, current
          company and photo stay hidden until a match. Off, they're shared with
          the companies whose roles you're interested in.
        </p>
      </div>

      <div className="built-for-leaders-grid">
        {builtForLeadersCards.map((card) => (
          <FeatureCard {...card} key={card.title} />
        ))}
      </div>
    </div>
  );
};

export default Maintain;
